/* eslint-disable jsx-a11y/media-has-caption */
type Props = {
  imageUrl: string;
};

export default function QuestionImage({ imageUrl }: Props) {
  if (!imageUrl) return null;
  return (
    <div className='mb-4'>
      <img src={imageUrl} alt='Sách số - Images' style={{ height: 220 }} />
    </div>
  );
}
